import React from "react";
import {
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from "reactstrap";

const PartnerInfoBlock = ({ partnerData }) => {
  if (!partnerData) return null;

  return (
    <>
      <hr />
      <h6 className="mb-3">Partner Information</h6>
      <Row>
        <Col md="6">
          <FormGroup>
            <Label>UUID</Label>
            <Input
              type="text"
              value={partnerData.uuid}
              disabled
              className="text-muted"
            />
            <small className="text-muted">Unique identifier</small>
          </FormGroup>
        </Col>

        <Col md="6">
          <FormGroup>
            <Label>Created By</Label>
            <Input
              type="text"
              value={partnerData.createdBy || "N/A"}
              disabled
              className="text-muted"
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col md="6">
          <FormGroup>
            <Label>Created At</Label>
            <Input
              type="text"
              value={partnerData.createdAt ? new Date(partnerData.createdAt).toLocaleString() : "N/A"}
              disabled
              className="text-muted"
            />
          </FormGroup>
        </Col>

        <Col md="6">
          <FormGroup>
            <Label>Last Updated</Label>
            <Input
              type="text"
              value={partnerData.updatedAt ? new Date(partnerData.updatedAt).toLocaleString() : "N/A"}
              disabled
              className="text-muted"
            />
          </FormGroup>
        </Col>
      </Row>
    </>
  );
};

export default PartnerInfoBlock;
